import React, { useEffect, useState } from "react";
import {
	Button,
	Divider,
	Flex,
	Icon,
	Stack,
	Text,
	useToast,
	useBreakpointValue
} from "@chakra-ui/react";
import { FaStore, FaMapMarkerAlt } from 'react-icons/fa';
import { FiArrowLeft, FiCornerDownRight, FiMapPin } from "react-icons/fi";
import { useHistory } from "react-router-dom";

import { useCart } from "../../hooks/cart";
import { useAuth } from "../../hooks/auth";
import { formatPrice } from "../../utils/format";
import api from "../../services/api";
import Header from "../../components/Header";
import ModalEndereco from "../../components/Finalizar/ModalEndereco";
import AgendarHorario from "../../components/Finalizar/AgendarHorario";
import Pagamentos from "../../components/Finalizar/Pagamentos";
import PayModal from "../../components/Finalizar/PayModal";
import ModalConferencia from "../../components/Finalizar/ModalConferencia";
import { Select } from "../../components/Inputs/InputSelect";
import AlertCancelPedido from "../../components/Finalizar/AlertCancelPedido";
import Indicador from "../../components/Finalizar/Indicador";
import ModalIndicadores from "../../components/Finalizar/ModalIndicadores";
import Loading from "../../components/Loading";

type OperacaoSelectData = {
	value: number;
	label: string;
}
type OperacaoData = {
	concluido: string;
	custo: string;
	estoque: string;
	id: number;
	indicador: string;
	indicador_desc: string;
	nome: string;
	operacao: string;
	pagto: string;
}
type EnderecoData = {
  id: string;
  cep: string;
  uf: string;
  cid: string;
  cidcod: string;
  bai: string;
  endereco: string;
  num: string;
  comp?: string;
  ponto_ref?: string;
  emp_cod: string;
  formatted_address: string;
  location: {
    lat: number;
    lng: number;
  };
}
type EntregaData = {
	entrega_domingo: string;
	entrega_padrao: string;
	entrega_sabado: string;
	entrega_tempo: string;
	operacao_padrao: string;
	prev_entrega: string;
}

const Finalizar: React.FC = () => {
	const isWideVersion = useBreakpointValue({
		base: false,
		lg: true,
	});

	const { user, company } = useAuth();
	const {
		cart,
		addCartEndereco,
		addCartOperacao,
		initCart,
		addCartVendedorPrevEntrega,
	} = useCart();
	const history = useHistory();
	const toast = useToast();

	const [loading, setLoading] = useState(true);

	const [retirar, setRetirar] = useState(false);
	const [opsSelect, setOpsSelect] = useState<OperacaoSelectData[]>([]);
	const [operacoes, setOperacoes] = useState<OperacaoData[]>([]);

	const [isOpenModalEndereco, setIsOpenModalEndereco] = useState(false);
	const [isOpenPayModal, setIsOpenPayModal] = useState(false);

	const [isOpenModalConferencia, setIsOpenModalConferencia] = useState(false);

	const [isOpenAlertCancelPedido, setIsOpenAlertCancelPedido] = useState(false);

	const [isOpenModalIndicadores, setIsOpenModalIndicadores] = useState(false);

	const [horarios, setHorarios] = useState([]);
	const [pays, setPays] = useState([]);
	const [enderecos, setEnderecos] = useState<EnderecoData[]>([]);
	const [entrega, setEntrega] = useState<EntregaData>({} as EntregaData);

  async function fetchPays() {
    try {
      await api.post('controle/pays', {
        pagamento: {
          id_cli: cart.consumidor ? '0' : cart.cliente.id,
          desc: 0,
          subtotal: cart.subTotal
        }
      }).then(async response => {
        const { data } = response;

        setEnderecos(data.enderecos);
        setEntrega(data.entrega);
        setHorarios(data.horarios);
        setOperacoes(data.operacoes);
        setPays(data.pays);

        const operacao = data.operacoes.find((op: any) =>
          op.id === data.entrega.operacao_padrao
        );

        const auxOp = data.operacoes.map((op: any) => {
          return {
            value: op.id,
            label: op.nome
          }
        });
        setOpsSelect(auxOp);

        addCartVendedorPrevEntrega({ id: user.id, nome: user.nome }, data.entrega.prev_entrega);

        if (data.entrega?.entrega_padrao === "R" && !cart.endereco_entrega?.endereco) {
          setRetirar(true);
          addCartEndereco(
            {
              ...company.endereco,
              id: '0',
              ponto_ref: company.endereco.ponto_ref ? company.endereco.ponto_ref : '',
              emp_cod: company.id
            },
            true
          );
        } else {
          setRetirar(false);
          if (!cart.endereco_entrega?.endereco) {
            if (data.enderecos?.length > 0) {
              addCartEndereco(data.enderecos[0], false);
            } else {
              addCartEndereco({} as EnderecoData, false);
            }
          }
        }

        if (!cart.operacao?.id) {
          addCartOperacao(operacao);
        }

        setLoading(false);
      }).catch(() => {
        setLoading(false);
      });
    }
    catch (error) {
      setLoading(false);
    }
    finally {
      setLoading(false);
    }
  }

	useEffect(() => {
    fetchPays();
	}, []);

	async function handleOperacao(event: any) {
		const operacao = operacoes.find((op: any) => op.id === Number(event));

		/* if (operacao?.id === 1) {
			operacao.pagto = 'N';
			operacao.indicador = 'S';
		} */

		operacao && addCartOperacao(operacao);
	};

	async function handleSubmitPedido() {
		await api.post('/controle/pedido', { pedido: cart })
			.then((response) => {
        const { data } = response;

        if (data.che === 'N') {
          toast({
            title: 'Pedido Falhou.',
            description: data.msg,
            status: 'error',
            duration: 5000,
            position: 'top-right',
            isClosable: true,
          });

          return;
        };

				toast({
					title: 'Pedido feito.',
					description: 'Seu pedido foi feito com sucesso!',
					status: 'success',
					duration: 5000,
					position: 'top-right',
					isClosable: true,
				});

				setIsOpenModalConferencia(false);
				initCart();
				history.push('/client');
			}).catch(err => {
				toast({
					title: 'Pedido falhou.',
					description: `Seu pedido falhou ao finalizar! - ${err}`,
					status: 'error',
					duration: 5000,
					position: 'top-right',
					isClosable: true,
				});
			});
	};

	return (
		<Flex
			w="100vw"
			h="100vh"
			flexDir="column"
			align="center"
			overflowX="hidden"
		>
			<Header isOpenCart={() => { }} />

			{loading ? (
				<Loading />
			) : (
				<Flex
					id="content"
					w={["100%", "90%"]}
					mt={["40px", "60px"]}
					direction={["column", "column", "column", "row"]}
				>
					{/* FINALIZA */}
					<Flex
						id="finalizar"
						flexDir="column"
						w="100%"
						p={["4", "6"]}
						pr="10"
					>
						{/* HEADER */}
						<Flex mb={["4", "6"]} align="center">
							<Button p="0" mr="2" bg="transparent" onClick={() => history.goBack()}>
								<Icon as={FiArrowLeft} color="blue.500" fontSize="30" />
							</Button>
							<Text fontSize={["20", "24"]}>Finalize seu pedido</Text>
						</Flex>

						{/* OPERAÇÂO */}
						{opsSelect.length > 0 && (
							<Flex fontSize={["12", "18"]}>
								<Select
									name="operacao"
									label="Operação (obrigatório)"
									defaultValue={cart.operacao.id ? cart.operacao.id : entrega.operacao_padrao}
									options={opsSelect}
									onChange={e => handleOperacao(e.target.value)}
								/>
							</Flex>
						)}

						{/* INDICADOR */}
						{cart.operacao.id && cart.operacao.indicador === 'S' && (
							<Indicador setIsOpenModalIndicadores={setIsOpenModalIndicadores} />
						)}

						{/* ENTREGAR / RETIRAR */}
						<Stack direction="row" spacing="4" mt="6">
							<Text
								as="button"
								fontSize={["18", "20"]}
								fontWeight="500"
								color={!cart.retirar ? 'blue.500' : 'gray.400'}
								pb="2"
								borderBottomWidth={2}
								borderBottomColor={!cart.retirar ? 'blue.500' : 'gray.400'}
								onClick={() => {
									setRetirar(false);
									enderecos.length > 0 && addCartEndereco(enderecos[0], false);
									// cart.consumidor && enderecos.length > 0
									//	? addCartEndereco(enderecos[0], false)
									//	: addCartEndereco({} as EnderecoData, false);
								}}
							>
								Entregar
							</Text>

							<Text
								as="button"
								fontSize={["18", "20"]}
								fontWeight="500"
								color={cart.retirar ? 'blue.500' : 'gray.400'}
								pb="2"
								borderBottomWidth={2}
								borderBottomColor={cart.retirar ? 'blue.500' : 'gray.400'}
								onClick={() => {
									setRetirar(true);
                  if (company.endereco)
                    addCartEndereco({ ...company.endereco, id: '0', emp_cod: company.id }, true);
								}}
							>
								Retirar
							</Text>
						</Stack>

						{/* ENDEREÇO SELECIONADO */}
						<Flex
							id="endereco"
							w="100%"
							mt="6"
							justify="space-between"
						>
							<Flex align="center">
								<Flex
									w="50px" h="50px"
									bg="gray.100"
									justify="center"
									align="center"
									borderRadius={8}
								>
									<Icon
										as={cart.retirar ? FaStore : cart.endereco_entrega?.id ? FaMapMarkerAlt : FiMapPin}
										fontSize={20}
									/>
								</Flex>

								<Flex flexDir='column' pl="4">
									{cart.endereco_entrega?.endereco ? (
										<>
											<Text fontSize={["15", "18"]} fontWeight="500" color="gray.700">
												{cart.endereco_entrega?.endereco}
												{cart.endereco_entrega.num && `, ${cart.endereco_entrega.num}`}
											</Text>
											<Text fontSize={["13", "14"]} fontWeight="500" color="gray.400">
												{cart.endereco_entrega.comp && `${cart.endereco_entrega.comp}, `}
												{cart.endereco_entrega?.bai}
												{cart.endereco_entrega.cid && `, ${cart.endereco_entrega.cid}`}
												{cart.endereco_entrega?.uf && ` - ${cart.endereco_entrega.uf}`}
											</Text>
										</>
									) : (
										<>
											<Text fontSize={["16", "18"]} fontWeight="500" color="gray.700">
												Nenhum endereço
											</Text>
											<Text fontSize={["13", "14"]} fontWeight="500" color="gray.400">
												Cadastre um endereço para entrega
											</Text>
										</>
									)}

								</Flex>
							</Flex>

							{!cart.retirar && (
								<Text
									as="button"
									color="blue.500"
									fontSize={["14", "18"]}
									fontWeight={["600", "500"]}
									onClick={() => setIsOpenModalEndereco(true)}
								>
									Trocar
								</Text>
							)}
						</Flex>

						{/* AGENDAR HORÁRIO */}
						<AgendarHorario horarios={horarios} entrega={entrega} />

						{/* PAGAMENTOS */}
						{cart.operacao.pagto === 'S' && (
							<Pagamentos isOpenPayModal={setIsOpenPayModal} />
						)}

						<Divider orientation='horizontal' my="8" />

						{/* BUTTONS */}
						<Stack spacing="4">
							<Button
								colorScheme="blue"
								fontSize={["18", "20"]}
								size='lg'
								isDisabled={
									!cart.operacao.id ||
									(cart.operacao.pagto === 'S' && cart.falta > 0) || !cart.endereco_entrega ||
									(cart.agendar && !cart.agendamento.data)
								}
								onClick={() => setIsOpenModalConferencia(true)}
							>
								Finalizar Pedido
							</Button>

							<Button
								colorScheme="blackAlpha"
								fontSize={["18", "20"]}
								size='lg'
								onClick={() => setIsOpenAlertCancelPedido(true)}
							>
								Cancelar Pedido
							</Button>
						</Stack>
					</Flex>

					{/* CART */}
					<Flex
						id="cart"
						flexDir="column"
						w="100%"
						pt={["0", "0", "0", "8"]}
						pb="8"
					>
						<Flex
							flexDir="column"
							borderRadius={8}
							boxShadow="2px 3px 3px 3px rgba(0, 0, 0, 0.2)"
							transition="boxShadow 0.9s"
							p="6"
							pt="4"
						>
							<Flex direction="column">
								<Text fontSize="13px" fontWeight="500" color="gray.300" mb="-1">
									{cart.consumidor ? 'Consumidor' : 'Cliente'}
								</Text>
								<Flex flexDir="column" ml="1">
									<Text fontSize="15px" fontWeight="500" color="gray.600">{cart.cliente.nome}</Text>
									<Text fontSize="13px" fontWeight="500" color="gray.500">{cart.cliente.doc}</Text>
								</Flex>
							</Flex>

							<Divider orientation='horizontal' mt="1" />

							{!isWideVersion && (
								<>
									<Flex py="1" direction="column">
										<Text fontSize="13px" fontWeight="500" color="gray.300" mb="-1">Vendedor</Text>
										<Flex justify="space-between">
											<Text fontSize="15px" fontWeight="500" color="gray.600">{user.nome}</Text>
											<Text fontSize="13px" fontWeight="500" color="gray.500">{user.email}</Text>
										</Flex>
									</Flex>

									<Divider orientation='horizontal' size="sm" />
								</>
							)}

							{cart.items?.map((item) => {
								return (
									<Flex
										key={item.id}
										flexDir="column" py="2"
										borderBottomWidth={1}
										borderBottomColor="gray.100"
									>
										<Flex justify="space-between">
											<Text fontSize="15px">{item.qtd}x {item.nome}</Text>
											<Text fontSize="15px">{formatPrice(item.total)}</Text>
										</Flex>

										{item.complementos?.map(comp => {
											return comp.qtd > 0 && (
												<Flex key={comp.codigo} px="2" color="gray.500">
													<Icon as={FiCornerDownRight} color="gray.300" />
													<Text fontSize="14px">{comp.qtd}x {comp.nome}</Text>
												</Flex>
											)
										})}
									</Flex>
								)
							})}

							<Flex direction="column" pt="4">
								<Flex justify="space-between">
									<Text fontSize="15" fontWeight="500" color="gray.400">SubTotal</Text>
									<Text fontSize="15" fontWeight="500" color="gray.400">{formatPrice(cart.subTotal)}</Text>
								</Flex>

								<Flex justify="space-between">
									<Text fontSize="15" fontWeight="500" color="gray.400">Taxa Entrega</Text>
									<Text fontSize="15" fontWeight="500" color="gray.400">{formatPrice(cart.taxa_entrega)}</Text>
								</Flex>

								<Flex justify="space-between">
									<Text fontSize="15" fontWeight="500" color="gray.800">Total</Text>
									<Text fontSize="15" fontWeight="500" color="gray.800">{formatPrice(cart.total)}</Text>
								</Flex>
							</Flex>
						</Flex>
					</Flex>
				</Flex>
			)}

			{isOpenModalIndicadores && (
				<ModalIndicadores
					isOpen={isOpenModalIndicadores}
					onRequestClose={setIsOpenModalIndicadores}
				/>
			)}

			{isOpenModalEndereco && (
				<ModalEndereco
					isOpen={isOpenModalEndereco}
					onRequestClose={setIsOpenModalEndereco}
					retirar={retirar}
					enderecos={enderecos}
					setEnderecos={setEnderecos}
				/>
			)}

			{isOpenPayModal && (
				<PayModal
					isOpen={isOpenPayModal}
					onRequestClose={setIsOpenPayModal}
					pays={pays}
				/>
			)}

			{isOpenModalConferencia && (
				<ModalConferencia
					isOpen={isOpenModalConferencia}
					onRequestClose={setIsOpenModalConferencia}
					handleSubmitPedido={handleSubmitPedido}
				/>
			)}

			<AlertCancelPedido
				isOpen={isOpenAlertCancelPedido}
				onRequestClose={setIsOpenAlertCancelPedido}
			/>
		</Flex>
	)
}

export default Finalizar;
